export default "__VITE_ASSET__CBWa4Bwy__"